import axios from "axios";

export const AxiosConfigBenchmarking = () => {
  const token = localStorage.getItem(
    `${process.env.REACT_APP_PREFIX_LOCAL}_access_token`
  );
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_BENCHMARKING_BASE_URL}/benchmarking`,
    headers: {},
  });

  return instance;
};
